import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Drafts, GetAppOutlined } from "@mui/icons-material";

export const HoverMouse = ({ data, downloadDocument, onIconBtnClick }: any) => {
    function MouseOver(event: any) {
        event.target.style.color = "#3576E5";
    }
    function MouseOut(event: any) {
        event.target.style.color = "";
    }

    return (
        <div className="icon-container-hover" style={{ display: "flex" }}>
            <Tooltip title="Download Document">
                <IconButton
                    style={{ marginTop: 5 }}
                    onClick={(e) => downloadDocument(e, data)}
                    onMouseOver={MouseOver}
                    onMouseOut={MouseOut}
                >
                    <GetAppOutlined id="icon-componenet" />
                </IconButton>
            </Tooltip>
            <Tooltip title="View Document">
                <IconButton
                    style={{ marginTop: 5 }}
                    onClick={(e) => onIconBtnClick(e, data, "assign", "pendingSource")}
                    onMouseOver={MouseOver}
                    onMouseOut={MouseOut}
                >
                    <Drafts id="icon-componenet" />
                </IconButton>
            </Tooltip>
        </div>
    );
};
